export default __webpack_public_path__ + "static/media/cook.63bfb7b3.svg";